import * as yup from "yup";

const signUpUpdatesSchema = yup.object().shape({
    email: yup
        .string()
        .email("Invalid email address")
        .required("Email is required"),
    receiveUpdates: yup.boolean().required().default(false),
});

const otpValidationSchema = yup.object().shape({
    newEmail: yup
        .string()
        .email("Invalid email address")
        .required("Email is required"),
    otp: yup.string().required().min(6).max(6),
    receiveUpdates: yup.boolean().required().default(false),
});

export { signUpUpdatesSchema, otpValidationSchema };